export default class ApiService {

	static get $inject(){
		return [
			'$q', '$http', '$cookies',
			'ApiService'
		];
	}

	constructor($q, $http, $cookies,
	            ApiService){

		this.api = ApiService.api;
		this.errors = ApiService.errors;
		this.successes = ApiService.successes;
		
		this.$q = $q;
		this.$http = $http;
		this.$cookies = $cookies;
		
	}

	//a.res(href="https://en.wikipedia.org/wiki/Snake_case", target="_blank") Snake Case.

	get service(){
		return {
			getStatus: {
				name:'getStatus',
				request: {
					type: 'GET',
					route: '/personal/access/status'
				},
				response: {
					success: {
						data: [
							{ name: 'Object (JSON)', type: 'Object', description: 'Object that holds all system status data that is relevant to current user code. Could be executed in parallel.' }
						]
					},
					error: { data: [
						this.errors.status,
						this.errors.state,
						this.errors.message
					] }
				},
				submit: (data)=>
					this.$http({
						url: this.api + '/personal/access/status',
						method: 'GET',
						data: data,
						headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
					})
			}


		}
	}

}



/** WEBPACK FOOTER **
 ** ./src/main/apiTest/services/api.service.personal.access.status.js
 **/